export default "__VITE_ASSET__DkdJl0hA__"